import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { debounceOnMicroQueue } from '../../../../../../../../shared/misc-utilities/misc-utils';
import { ObjectClassService } from '../../../../../../../shared/misc-services/object-class.service';
import { RootFocusedAnnotationService } from '../../../../utils/root-focused-annotation.service';

@Component({
  selector: 'h3-focused-annotation-label',
  templateUrl: './focused-annotation-label.component.html',
  styleUrls: ['./focused-annotation-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FocusedAnnotationLabelComponent implements OnInit {
  classLabel$!: Observable<string>;
  private focusedAnnotationService = inject(RootFocusedAnnotationService);

  private objectClassService = inject(ObjectClassService);

  ngOnInit() {
    this.classLabel$ = this.getClassLabel$();
  }

  private getClassLabel$() {
    return this.focusedAnnotationService.getAnnotationStore$().pipe(
      debounceOnMicroQueue(),
      switchMap((annotationStore) => {
        if (!annotationStore) {
          return of('Scene');
        }
        return this.focusedAnnotationService
          .extractClassStore(annotationStore)
          .$.pipe(
            map(
              (className) =>
                this.objectClassService.getClassLabel(className) ?? '',
            ),
          );
      }),
    );
  }
}
